import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App.tsx';
import { DocumentLanguageSync } from './i18n';
import { ToastProvider } from './components/ui';
import { OfflineNotice } from './pwa/OfflineNotice';
import { ServiceStatusNotice } from './pwa/ServiceStatusNotice';
import { installGlobalErrorReporting } from './monitoring/reportError';
import { PwaUpdater } from './pwa/PwaUpdater';
import { clearRuntimeCachesOnSignOut } from './pwa/clearCaches';
import { captureInstallPrompt } from './pwa/useInstallPrompt';
import './index.css';

clearRuntimeCachesOnSignOut(store);
installGlobalErrorReporting();
captureInstallPrompt();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <DocumentLanguageSync />
        <App />
        <ToastProvider>
          <PwaUpdater />
        </ToastProvider>
        <OfflineNotice />
        <ServiceStatusNotice />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
